import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useFlags } from "@/hooks/useFlags";

// Voorstel 17 — werkveldschakelaar: Totaal · Actief · Bouwkundig · BMI · Overig, subfilter NL · BE · Aanbesteding. Standaard per rol, per gebruiker bewaard.
const Ctx = createContext({ werkveld: "totaal", regio: null, kanaal: null, zet: () => {}, params: {}, actief: false, labels: {} });
export const WERKVELD_LABELS = { totaal: "Totaal", actief: "Actief", bouwkundig: "Bouwkundig", bmi: "BMI", overig: "Overig" };

export function WerkveldProvider({ children }) {
  const { aan } = useFlags();
  const [v, setV] = useState(() => { try { return JSON.parse(localStorage.getItem("werkveld") || "null") || { werkveld: "totaal", regio: null, kanaal: null }; } catch { return { werkveld: "totaal", regio: null, kanaal: null }; } });
  useEffect(() => {
    if (!localStorage.getItem("token")) return;
    api.get("/werkvelden/voorkeur").then((r) => { const d = { werkveld: r.data.werkveld || "totaal", regio: r.data.regio || null, kanaal: r.data.kanaal || null }; setV(d); localStorage.setItem("werkveld", JSON.stringify(d)); }).catch(() => {});
  }, []);
  const zet = useCallback((patch) => {
    setV((oud) => {
      const n = { ...oud, ...patch };
      localStorage.setItem("werkveld", JSON.stringify(n));
      api.put("/werkvelden/voorkeur", n).catch(() => {});
      return n;
    });
  }, []);
  const actief = aan("werkvelden_v1");
  const params = useMemo(() => (actief ? { ...(v.werkveld && v.werkveld !== "totaal" ? { werkveld: v.werkveld } : {}), ...(v.regio ? { regio: v.regio } : {}), ...(v.kanaal ? { kanaal: v.kanaal } : {}) } : {}), [v, actief]);
  return <Ctx.Provider value={{ ...v, zet, params, actief, labels: WERKVELD_LABELS }}>{children}</Ctx.Provider>;
}

export const useWerkveld = () => useContext(Ctx);

export function werkveldQuery(params) {
  const q = new URLSearchParams(params).toString();
  return q ? `&${q}` : "";
}
